import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, type Messaging } from 'firebase/messaging';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC6Gox9YRojB21q9B_hQ65gO6jEsBdczv8",
  authDomain: "t1-fx-team.firebaseapp.com",
  projectId: "t1-fx-team",
  storageBucket: "t1-fx-team.firebasestorage.app",
  messagingSenderId: "252456746419",
  appId: "1:252456746419:web:24506cb924c825afc59fc6",
  measurementId: "G-1L3WJ91550"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);

// Initialize Firebase Cloud Messaging
let messaging: Messaging | null = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.warn('Firebase Messaging not supported:', error);
}

export { messaging };

export default app; 